module.exports = __webpack_public_path__ + "static/media/shells_browser2-fs8.7466c615.png";